export const baseRoutes = [
  {
    path: "/Login",
    name: "Login",
    component: () => import("@/views/Login/"),
    hidden: true,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/FindPassword",
    name: "FindPassword",
    component: () => import("@/views/Login/FindPassword"),
    hidden: true,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/ChangePhone",
    name: "ChangePhone",
    component: () => import("@/views/Login/ChangePhone"),
    hidden: true,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/",
    name: "Main",
    redirect: "/Scheduler",
    component: () => import("@/layout/Main/"),
    meta: {
      title: 'FrontPage'
    },
    children: [
      {
        path: "/Scheduler",
        name: "Scheduler",
        component: ()=>import("@/views/Scheduler/"),
        meta: {
          title:'Scheduler',
        }
      },
      {
        path: "/PMS",
        name: "PMS",
        component: ()=>import("@/views/PMS/Project"),
        meta: {
          title:'PMS',
        }
      },
      {
        path: "/Sales",
        name: "Sales",
        component: ()=>import("@/views/Sales"),
        meta: {
          title:'Sales',
        }
      },
      {
        path: "/Purchase",
        name: "Purchase",
        component: ()=>import("@/views/Purchase"),
        meta: {
          title:'Purchase',
        }
      },
      {
        path: "/Supplier",
        name: "Supplier",
        component: ()=>import("@/views/Supplier"),
        meta: {
          title:'Supplier',
        }
      },
      {
        path:'/Warehouse',
        name: "Warehouse",
        component: ()=>import("@/views/Warehouse/index"),
        meta: {
          title:'Warehouse',
        }
      },
      {
        path:'/Shipping',
        name: "Shipping",
        component: ()=>import("@/views/Shipping/index"),
        meta: {
          title:'Shipping',
        }
      },
      {
        path: "/ToolBox",
        name: "ToolBox",
        component: ()=>import("@/views/ToolBox/"),
        meta: {
          title:'ToolBox',
        }
      },
      {
        path: "/OneDrive",
        name: "OneDrive",
        component: ()=>import("@/views/OneDrive/"),
        meta: {
          title:'OneDrive',
        }
      },
      {
        path: "/Setting",
        name: "Setting",
        component: () => import("@/views/Setting/"),
        meta: {
          title: 'Setting',
        }
      },
      {
        path: "/401",
        name: "Error401",
        component: () => import("@/views/Error/Error401/"),
        meta: {
          title: '401',
          noCache: true
        }
      }]
  }
]
